// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__oE56Q","file":"styles_file__q1NeN"};